<template>
    <div>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="9">
                    <el-form-item label="成就名字" prop="active_name">
                        <el-input v-model="form.active_name"></el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :span="9">
                    <el-form-item label="活动状态" prop="status">
                        <el-select v-model="form.status" placeholder="请选择活动状态">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of status" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <h3>
            <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        </h3>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="active_name" label="成就名字" fixed="left"></el-table-column>
            <el-table-column prop="timetype" label="成就类型" align="center">
                <template slot-scope="scope">
                    {{ achievement_name[scope.row.type_name] }}
                </template>
            </el-table-column>
            <el-table-column prop="amount" label="达标数量" align="center"></el-table-column>
            <el-table-column prop="point" label="奖励积分" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">
                    {{ scope.row.status === 1 ? '开启' : '暂停' }}
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" width="130" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <add-modal :dialogVisible="addFlag" :info="info" :rule_list="rule_list" @closeModal="closeAddModal" v-if="addFlag" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import AddModal from './add/index.vue';
export default {
    components: {
        AddModal,
    },
    data() {
        return {
            times: [
                { label: '每天', value: 'dayly' },
                { label: '每周', value: 'weekly' },
                { label: '每月', value: 'monthly' },
                { label: '固定时间段内', value: 'fixed' },
            ],
            status: [
                { label: '进行中', value: 1 },
                { label: '暂停', value: 0 },
            ],
            active_type_list: [
                { label: '任务', value: 'task' },
                { label: '成就', value: 'achievement' },
            ],
            timetype: {
                dayly: '每天',
                weekly: '每周',
                monthly: '每月',
            },
            form: {
                active_name: '',
                active_id: '',
                active_type: '',
                type: '',
                timetype: '',
                status: '',
            },
            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,

            // rule
            rule_schema_name: {
                achievement: '成就',
                save_prompt_time_epoch: '收藏prompt(周期)',
                save_prompt_time_range: '收藏prompt(固定时间内)',
                share_prompt_time_epoch: '分享prompt(周期)',
                share_prompt_time_range: '分享prompt(固定时间内)',
                like_prompt_time_epoch: 'like prompt(周期)',
                like_prompt_time_range: 'like prompt(固定时间内)',
                create_prompt_time_epoch: '创建prompt(周期)',
                create_prompt_time_range: '创建prompt(固定时间内)',
                follow_user_time_epoch: 'follow user(周期)',
                follow_user_time_range: 'follow user(固定时间内)',
                follow_thirdapp: 'follow 社交平台',
            },
            achievement_name: {
                'create_prompt': '创建prompt数量',
                'liked_prompt': 'prompt被like次数',
                'saved_prompt': 'prompt被收藏次数',
                'share_prompt': 'prompt被分享次数',
                'coped_prompt': 'prompt被coped次数',
                follow: '累计关注用户(follow)',
                follower: '粉丝数量(follower)',
            },
            info: {},
            rule_list: [
                {}
            ],
            addFlag: false,
        };
    },
    created() {
        this.getActiveList();
    },
    methods: {
        async getActiveList(_params = {}) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                    type: 'achievement',
                };
                this.loading = true;
                const { data } = await serverApi.activeList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        handDetail(data) {
            this.getUserDetail(data.uid);
            // this.detail = data;
            // this.dialogFormVisible= true
        },
        handleCurrentChange(val) {
            this.getActiveList({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.getActiveList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.getActiveList(this.form);
        },

        async confirm(item) {
            try {
                const params = {
                    uid: item.uid,
                    open_create: !item.open_create,
                };
                const { data } = await serverApi.opencreate(params);
                if (data.code !== 0) throw new Error(data.error);
                this.getUserList();
                this.$message({
                    message: 'Edit success',
                    type: 'success',
                });
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },

        handleAdd() {
            this.info = {};
            this.addFlag = true;
        },
        edit(data) {
            this.info = data;
            this.addFlag = true;
        },
        closeAddModal() {
            this.addFlag = false;
            this.getActiveList();
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
    button {
        width: 100px;
    }
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
